/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_LabelInputs */

const et_plan_website_label = /** @type {(inputs: Plan_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veebileht`)
};

const en_plan_website_label = /** @type {(inputs: Plan_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Plan_Website_LabelInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_label = /** @type {((inputs?: Plan_Website_LabelInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_LabelInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_label(inputs)
	return en_plan_website_label(inputs)
});